import * as React from 'react';
import { UserDetails } from 'src/modules/User/components/Details';

export const UserInfo: React.FC = () => <UserDetails />;
